
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'customer-portal-app',
  currentProjectVersion: 'static-1.1134',
  depVersions: {
  "customer-portal-app": "static-1.1134",
  "apollo-dlb": "static-3.73",
  "client-types": "static-1.425",
  "data-fetching-client": "static-1.9199",
  "emoji-mart": "static-3.4",
  "enviro": "static-4.345",
  "growth-payments-core": "static-1.24020",
  "head-dlb": "static-1.4465",
  "hs-lodash": "static-4.45",
  "hs-promise-utils": "static-1.5047",
  "hs-test-utils": "static-1.7470",
  "hub-http": "static-1.5499",
  "hub-http-shared-msw-handlers": "static-1.8849",
  "hubspot-dlb": "static-2.1707",
  "hubspot-prosemirror": "static-1.16940",
  "hubspot-url-utils": "static-1.3531",
  "HubStyleTokens": "static-2.10995",
  "I18n": "static-7.1485",
  "immutable": "static-2.19",
  "jasmine-runner": "static-1.5922",
  "payment-link-components": "static-1.22324",
  "prosemirror": "static-1.13",
  "quartz": "static-1.6318",
  "quartz-core": "static-1.5537",
  "react": "static-7.151",
  "react-colorpicker": "static-2.9749",
  "react-dlb": "static-1.64",
  "react-utils": "static-2.4912",
  "rich-text-lib": "static-1.18948",
  "transmute": "static-2.77",
  "ui-addon-upgrades": "static-9.17192",
  "ui-components-test-utils": "static-1.5133",
  "UIComponents": "static-3.7942",
  "foundations-assets": "static-1.4345",
  "foundations-components": "static-1.7053",
  "foundations-theming": "static-1.3884",
  "foundations-theming-specialty": "static-1.1600",
  "framer-motion": "static-1.58",
  "history": "static-4.47",
  "metrics-js": "static-1.9058",
  "PortalIdParser": "static-2.319",
  "portals-platform-lib": "static-1.233",
  "quartz-config": "static-1.96",
  "quick-fetch": "static-1.3503",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "react-dom": "static-7.85",
  "react-flip-move": "static-1.60",
  "react-rhumb": "static-1.16176",
  "react-router-dom": "static-5.26",
  "sanitize-text": "static-1.7678",
  "styled-components": "static-2.64",
  "tanstack-table": "static-1.23",
  "ui-addon-draggable": "static-3.4326",
  "ui-addon-react-router-dom": "static-1.9095",
  "usage-tracker": "static-1.6894",
  "usage-tracker-anonymous": "static-1.5311",
  "usage-tracker-core": "static-1.6744",
  "apollo-stack-hubspot": "static-3.69",
  "hs-promise-rejection-tracking": "static-1.4918",
  "raven": "static-3.5386",
  "raven-hubspot": "static-1.5693",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "react-redux": "static-7.16",
  "redux": "static-4.16",
  "bend-plugin-trellis-migration": "static-1.3015",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.2595",
  "quartz-webpack": "static-1.2542",
  "fast-json-stable-stringify": "static-1.4",
  "graphql": "static-1.72",
  "commerce-analytics-service-client": "static-1.3182",
  "frontend-preferences-client": "static-1.7480",
  "laboratory-lib": "static-3.6654",
  "onboarding-scopes": "static-1.6001",
  "rpc-client-utils": "static-1.4179",
  "ui-addon-opt": "static-4.7963",
  "HeadJS": "static-2.647",
  "hs-test-utils-bend-plugin": "static-1.2581",
  "msw": "static-1.39",
  "testing-library": "static-1.140",
  "ts-schema": "static-1.3679",
  "webpack-env": "static-1.54",
  "content-assistance-lib": "static-1.7140",
  "cssUtils": "static-1.637",
  "customer-data-objects": "static-1.7168",
  "customer-data-ui-utilities": "static-1.9290",
  "HubStyle": "static-2.11303",
  "knowledge-content-types": "static-1.8152",
  "PatternValidationJS": "static-1.437",
  "react-input-autosize": "static-2.17",
  "StyleGuideUI": "static-3.478",
  "ui-addon-emoji-picker": "static-1.9419",
  "ui-addon-i18n": "static-1.10559",
  "ui-business-units-lib": "static-1.8470",
  "ui-shepherd-react": "static-3.9602",
  "video-components-external": "static-1.9884",
  "i18n-data": "static-1.211",
  "moment-timezone": "static-5.73",
  "jasmine": "static-4.3799",
  "commerce-tours-lib": "static-1.5328",
  "customer-data-properties": "static-1.50021",
  "getting-started-shared-tasks": "static-1.17214",
  "growth-onboarding-reliability": "static-1.4648",
  "onboarding-tours": "static-1.15929",
  "reference-resolvers-lite": "static-1.7570",
  "sales-checkout-service-client": "static-1.3194",
  "ui-addon-iframeable": "static-1.8448",
  "user-context": "static-1.4651",
  "dispatcher": "static-1.126",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.724",
  "hubspotter-http": "static-1.4187",
  "hubspotter-http-shared-msw-handlers": "static-1.8847",
  "icons": "static-2.599",
  "mobile-manifest-mixins": "static-1.420",
  "ui-fonts": "static-1.335",
  "csstype": "static-1.50",
  "hs-story-utils": "static-1.8891",
  "data-token-picker": "static-1.15617",
  "FileManagerLib": "static-1.37796",
  "property-translator": "static-1.4893",
  "atom": "static-1.4654",
  "feature-store-service-types": "static-1.4109",
  "growth-monetization-service-types": "static-1.4116",
  "merchandise-lib": "static-1.248",
  "purchase-motions-components": "static-1.5044",
  "salesImages": "static-1.514",
  "self-service-api": "static-1.9733",
  "SharedI18nStrings": "static-1.175",
  "upgrade-management-service-types": "static-1.4100",
  "foundations-components-test-utils": "static-1.4537",
  "react-select-plus": "static-1.65",
  "react-virtualized": "static-2.87",
  "ui-images": "static-2.999",
  "bend-plugin-foundations-components": "static-1.3322",
  "floating-ui": "static-1.46",
  "react-aria": "static-1.44",
  "bend-plugin-foundations-theming": "static-1.2367",
  "foundations-theming-base": "static-1.2869",
  "stylex": "static-1.22",
  "js-cookie": "static-1.18",
  "autolinker": "static-3.11",
  "sanitize": "static-1.3931",
  "bender-build-tools": "static-1.2668",
  "superstore": "static-1.4252",
  "feedback-loader": "static-1.28335",
  "ai-components-ui-library": "static-1.7662",
  "react-transition-group": "static-1.7",
  "ui-addon-video-player": "static-1.8287",
  "ui-coaching-tips": "static-1.27256",
  "sassPrefix": "static-1.145",
  "inbound-db-properties-service-client": "static-1.3473",
  "react-dnd-compat": "static-1.4165",
  "react-immutable-proptypes": "static-2.8",
  "react-immutable-render-mixin": "static-1.9",
  "avatar-components": "static-1.2025",
  "redux-thunk": "static-2.43",
  "reference-resolvers": "static-1.7732",
  "reselect": "static-2.16",
  "apollo-link-hub-http": "static-2.4216",
  "content-media-composition-data-lib": "static-1.10318",
  "content-media-compositions": "static-2.14325",
  "idb-keyval": "static-1.34",
  "immer": "static-1.33",
  "immerable": "static-1.3621",
  "magpie-lib": "static-1.5124",
  "magpie-types": "static-1.4584",
  "media-bridge-lib": "static-1.18172",
  "video-data-lib": "static-1.33542",
  "commerce-products-lib": "static-1.8095",
  "crm-message-bus": "static-1.41706",
  "growth-data-modal": "static-1.4850",
  "hubspot-apollo-client": "static-1.4333",
  "onboarding-tours-client": "static-1.4143",
  "calling-global-api": "static-1.62901",
  "calling-internal-common": "static-1.30832",
  "calling-lifecycle-internal": "static-1.64283",
  "calling-lifecycle-messages": "static-1.56577",
  "conditional-properties-service-client": "static-1.3414",
  "crm-links": "static-1.5714",
  "customer-data-objects-ui-components": "static-1.12519",
  "customer-data-property-utils": "static-1.7518",
  "external-options-client-types": "static-1.3633",
  "file-manager-components": "static-1.22156",
  "framework-data-schema-resolvers": "static-1.6400",
  "google-libphonenumber": "static-1.27",
  "inbound-db-associations-writes-service-client": "static-1.2736",
  "inbound-db-meta-service-client": "static-1.3240",
  "inbounddb-objects-service-types": "static-1.3720",
  "meetings-icalendar-utils-lib": "static-1.72",
  "multi-currency-client-types": "static-1.3250",
  "object-builder-ui-client": "static-1.47197",
  "pipeline-validation-client-types": "static-1.3474",
  "property-value-citations": "static-1.635",
  "smart-property-lib": "static-1.4991",
  "tiered-pricing": "static-1.449",
  "ui-addon-form-validation": "static-1.10518",
  "growth-onboarding-confetti": "static-1.2568",
  "growth-onboarding-next-action-utils": "static-1.943",
  "navigation-components": "static-1.16625",
  "ui-shepherd-tracker": "static-1.6983",
  "ui-universal-auth": "static-1.8377",
  "batch-promise": "static-1.1107",
  "navigation-messaging": "static-1.5952",
  "getting-started-shared-tasks-store": "static-1.16332",
  "audio-components": "static-1.5308",
  "FileManagerCore": "static-1.37655",
  "FileManagerImages": "static-1.35307",
  "video-components": "static-1.11887",
  "nav-client-types": "static-1.1799",
  "purchase-motions-api": "static-1.5046",
  "signup-constants": "static-1.17875",
  "signup-ui-url-generator": "static-2.7572",
  "trials-service-types": "static-1.3517",
  "chatspot-client-types": "static-1.10206",
  "chatspot-core": "static-1.19460",
  "ContentUtils": "static-1.66912",
  "copilot-toolkit": "static-1.9855",
  "growth-onboarding-feedback-components": "static-1.6032",
  "hls.js": "static-1.29",
  "reactive-lib": "static-1.257",
  "simple-logging-lib": "static-1.2507",
  "customer-data-tracking": "static-1.6406",
  "products-iframe-lib": "static-1.6673",
  "products-ui-components-shared-msw-handlers": "static-1.9231",
  "calling-error-reporting": "static-1.30838",
  "shared-worker-versioning": "static-1.10583",
  "calling-usage-tracker": "static-1.6074",
  "calling-orchestration-shared-library": "static-1.34080",
  "conversations-skeleton-state": "static-1.6828",
  "usage-tracker-container": "static-1.6884",
  "location-customization-utils-lib": "static-1.7830",
  "crm-pipelines-api-client-types": "static-1.3594",
  "framework-builder-read-service-client": "static-1.3563",
  "framework-data-schema-quick-fetch": "static-1.6305",
  "persist-promise": "static-1.3264",
  "breeze-intelligence-kit": "static-1.4945",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.8932",
  "fsm": "static-1.3208",
  "policy-lib": "static-1.6294",
  "react-tinymce": "static-1.53941",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.8995",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.53067",
  "tinymce-plugins": "static-1.56181",
  "tinymce-themes": "static-1.55037",
  "cropperjs": "static-1.10",
  "redux-toolkit": "static-1.7",
  "urlinator": "static-1.4063",
  "video-embed": "static-1.34376",
  "content-icons-ui": "static-1.2052",
  "social-insights-client-types": "static-1.20730",
  "eligibility-engine-service-types": "static-1.2798",
  "markdown-it": "static-1.6",
  "cms-field-types": "static-1.4212",
  "underscore": "static-1.8",
  "sales-views-client-types": "static-1.3777",
  "calling-orchestration-schema": "static-1.34305",
  "crm-record-cards-service-types": "static-1.3223",
  "highcharts": "static-8.94",
  "trellis-story-utils": "static-1.4034",
  "storybook-react": "static-1.22",
  "hub-http-contrib": "static-1.2626",
  "interframe": "static-3.4261",
  "tinymce-data": "static-1.39152",
  "ui-addon-sales-email": "static-1.4721",
  "codemirror": "static-5.85",
  "layout-dnd-components": "static-1.11569",
  "layout-dnd-utils": "static-1.10544",
  "react-codemirror": "static-1.10162",
  "ui-brand-identity-lib": "static-1.12799",
  "NamespacedHubStyle": "static-2.8696",
  "outpost": "static-1.3809",
  "diff-match-patch": "static-1.7",
  "ContentData": "static-1.66987",
  "layout-data-lib": "static-1.8869",
  "browser-eslint": "static-2.57",
  "advanced-menus-core": "static-1.14411",
  "advanced-menus-lib": "static-1.11430",
  "ExportDialog": "static-6.9959",
  "ui-memberships-settings-lib": "static-1.32722",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.14410",
  "ReduxMessenger": "static-2.9950",
  "simple-menus-lib": "static-1.15927"
},
  depPathPrefixes: {
  "customer-portal-app": "/customer-portal-app/static-1.1134",
  "apollo-dlb": "/apollo-dlb/static-3.73",
  "client-types": "/client-types/static-1.425",
  "data-fetching-client": "/data-fetching-client/static-1.9199",
  "emoji-mart": "/emoji-mart/static-3.4",
  "enviro": "/enviro/static-4.345",
  "growth-payments-core": "/growth-payments-core/static-1.24020",
  "head-dlb": "/head-dlb/static-1.4465",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hs-promise-utils": "/hs-promise-utils/static-1.5047",
  "hs-test-utils": "/hs-test-utils/static-1.7470",
  "hub-http": "/hub-http/static-1.5499",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.8849",
  "hubspot-dlb": "/hubspot-dlb/static-2.1707",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.16940",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.3531",
  "HubStyleTokens": "/HubStyleTokens/static-2.10995",
  "I18n": "/I18n/static-7.1485",
  "immutable": "/immutable/static-2.19",
  "jasmine-runner": "/jasmine-runner/static-1.5922",
  "payment-link-components": "/payment-link-components/static-1.22324",
  "prosemirror": "/prosemirror/static-1.13",
  "quartz": "/quartz/static-1.6318",
  "quartz-core": "/quartz-core/static-1.5537",
  "react": "/react/static-7.151",
  "react-colorpicker": "/react-colorpicker/static-2.9749",
  "react-dlb": "/react-dlb/static-1.64",
  "react-utils": "/react-utils/static-2.4912",
  "rich-text-lib": "/rich-text-lib/static-1.18948",
  "transmute": "/transmute/static-2.77",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17192",
  "ui-components-test-utils": "/ui-components-test-utils/static-1.5133",
  "UIComponents": "/UIComponents/static-3.7942",
  "foundations-assets": "/foundations-assets/static-1.4345",
  "foundations-components": "/foundations-components/static-1.7053",
  "foundations-theming": "/foundations-theming/static-1.3884",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.1600",
  "framer-motion": "/framer-motion/static-1.58",
  "history": "/history/static-4.47",
  "metrics-js": "/metrics-js/static-1.9058",
  "PortalIdParser": "/PortalIdParser/static-2.319",
  "portals-platform-lib": "/portals-platform-lib/static-1.233",
  "quartz-config": "/quartz-config/static-1.96",
  "quick-fetch": "/quick-fetch/static-1.3503",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "react-dom": "/react-dom/static-7.85",
  "react-flip-move": "/react-flip-move/static-1.60",
  "react-rhumb": "/react-rhumb/static-1.16176",
  "react-router-dom": "/react-router-dom/static-5.26",
  "sanitize-text": "/sanitize-text/static-1.7678",
  "styled-components": "/styled-components/static-2.64",
  "tanstack-table": "/tanstack-table/static-1.23",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4326",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9095",
  "usage-tracker": "/usage-tracker/static-1.6894",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5311",
  "usage-tracker-core": "/usage-tracker-core/static-1.6744",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.69",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.4918",
  "raven": "/raven/static-3.5386",
  "raven-hubspot": "/raven-hubspot/static-1.5693",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "react-redux": "/react-redux/static-7.16",
  "redux": "/redux/static-4.16",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3015",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.2595",
  "quartz-webpack": "/quartz-webpack/static-1.2542",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "graphql": "/graphql/static-1.72",
  "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3182",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7480",
  "laboratory-lib": "/laboratory-lib/static-3.6654",
  "onboarding-scopes": "/onboarding-scopes/static-1.6001",
  "rpc-client-utils": "/rpc-client-utils/static-1.4179",
  "ui-addon-opt": "/ui-addon-opt/static-4.7963",
  "HeadJS": "/HeadJS/static-2.647",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2581",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.140",
  "ts-schema": "/ts-schema/static-1.3679",
  "webpack-env": "/webpack-env/static-1.54",
  "content-assistance-lib": "/content-assistance-lib/static-1.7140",
  "cssUtils": "/cssUtils/static-1.637",
  "customer-data-objects": "/customer-data-objects/static-1.7168",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9290",
  "HubStyle": "/HubStyle/static-2.11303",
  "knowledge-content-types": "/knowledge-content-types/static-1.8152",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "StyleGuideUI": "/StyleGuideUI/static-3.478",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9419",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.10559",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.8470",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.9602",
  "video-components-external": "/video-components-external/static-1.9884",
  "i18n-data": "/i18n-data/static-1.211",
  "moment-timezone": "/moment-timezone/static-5.73",
  "jasmine": "/jasmine/static-4.3799",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.5328",
  "customer-data-properties": "/customer-data-properties/static-1.50021",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.17214",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.4648",
  "onboarding-tours": "/onboarding-tours/static-1.15929",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.7570",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3194",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.8448",
  "user-context": "/user-context/static-1.4651",
  "dispatcher": "/dispatcher/static-1.126",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.724",
  "hubspotter-http": "/hubspotter-http/static-1.4187",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.8847",
  "icons": "/icons/static-2.599",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.420",
  "ui-fonts": "/ui-fonts/static-1.335",
  "csstype": "/csstype/static-1.50",
  "hs-story-utils": "/hs-story-utils/static-1.8891",
  "data-token-picker": "/data-token-picker/static-1.15617",
  "FileManagerLib": "/FileManagerLib/static-1.37796",
  "property-translator": "/property-translator/static-1.4893",
  "atom": "/atom/static-1.4654",
  "feature-store-service-types": "/feature-store-service-types/static-1.4109",
  "growth-monetization-service-types": "/growth-monetization-service-types/static-1.4116",
  "merchandise-lib": "/merchandise-lib/static-1.248",
  "purchase-motions-components": "/purchase-motions-components/static-1.5044",
  "salesImages": "/salesImages/static-1.514",
  "self-service-api": "/self-service-api/static-1.9733",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.175",
  "upgrade-management-service-types": "/upgrade-management-service-types/static-1.4100",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.4537",
  "react-select-plus": "/react-select-plus/static-1.65",
  "react-virtualized": "/react-virtualized/static-2.87",
  "ui-images": "/ui-images/static-2.999",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3322",
  "floating-ui": "/floating-ui/static-1.46",
  "react-aria": "/react-aria/static-1.44",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2367",
  "foundations-theming-base": "/foundations-theming-base/static-1.2869",
  "stylex": "/stylex/static-1.22",
  "js-cookie": "/js-cookie/static-1.18",
  "autolinker": "/autolinker/static-3.11",
  "sanitize": "/sanitize/static-1.3931",
  "bender-build-tools": "/bender-build-tools/static-1.2668",
  "superstore": "/superstore/static-1.4252",
  "feedback-loader": "/feedback-loader/static-1.28335",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.7662",
  "react-transition-group": "/react-transition-group/static-1.7",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8287",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.27256",
  "sassPrefix": "/sassPrefix/static-1.145",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3473",
  "react-dnd-compat": "/react-dnd-compat/static-1.4165",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "avatar-components": "/avatar-components/static-1.2025",
  "redux-thunk": "/redux-thunk/static-2.43",
  "reference-resolvers": "/reference-resolvers/static-1.7732",
  "reselect": "/reselect/static-2.16",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4216",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.10318",
  "content-media-compositions": "/content-media-compositions/static-2.14325",
  "idb-keyval": "/idb-keyval/static-1.34",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.3621",
  "magpie-lib": "/magpie-lib/static-1.5124",
  "magpie-types": "/magpie-types/static-1.4584",
  "media-bridge-lib": "/media-bridge-lib/static-1.18172",
  "video-data-lib": "/video-data-lib/static-1.33542",
  "commerce-products-lib": "/commerce-products-lib/static-1.8095",
  "crm-message-bus": "/crm-message-bus/static-1.41706",
  "growth-data-modal": "/growth-data-modal/static-1.4850",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4333",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4143",
  "calling-global-api": "/calling-global-api/static-1.62901",
  "calling-internal-common": "/calling-internal-common/static-1.30832",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.64283",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.56577",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3414",
  "crm-links": "/crm-links/static-1.5714",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12519",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.7518",
  "external-options-client-types": "/external-options-client-types/static-1.3633",
  "file-manager-components": "/file-manager-components/static-1.22156",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6400",
  "google-libphonenumber": "/google-libphonenumber/static-1.27",
  "inbound-db-associations-writes-service-client": "/inbound-db-associations-writes-service-client/static-1.2736",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3240",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.3720",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.72",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3250",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.47197",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3474",
  "property-value-citations": "/property-value-citations/static-1.635",
  "smart-property-lib": "/smart-property-lib/static-1.4991",
  "tiered-pricing": "/tiered-pricing/static-1.449",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10518",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.2568",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.943",
  "navigation-components": "/navigation-components/static-1.16625",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.6983",
  "ui-universal-auth": "/ui-universal-auth/static-1.8377",
  "batch-promise": "/batch-promise/static-1.1107",
  "navigation-messaging": "/navigation-messaging/static-1.5952",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.16332",
  "audio-components": "/audio-components/static-1.5308",
  "FileManagerCore": "/FileManagerCore/static-1.37655",
  "FileManagerImages": "/FileManagerImages/static-1.35307",
  "video-components": "/video-components/static-1.11887",
  "nav-client-types": "/nav-client-types/static-1.1799",
  "purchase-motions-api": "/purchase-motions-api/static-1.5046",
  "signup-constants": "/signup-constants/static-1.17875",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7572",
  "trials-service-types": "/trials-service-types/static-1.3517",
  "chatspot-client-types": "/chatspot-client-types/static-1.10206",
  "chatspot-core": "/chatspot-core/static-1.19460",
  "ContentUtils": "/ContentUtils/static-1.66912",
  "copilot-toolkit": "/copilot-toolkit/static-1.9855",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6032",
  "hls.js": "/hls.js/static-1.29",
  "reactive-lib": "/reactive-lib/static-1.257",
  "simple-logging-lib": "/simple-logging-lib/static-1.2507",
  "customer-data-tracking": "/customer-data-tracking/static-1.6406",
  "products-iframe-lib": "/products-iframe-lib/static-1.6673",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.9231",
  "calling-error-reporting": "/calling-error-reporting/static-1.30838",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.10583",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6074",
  "calling-orchestration-shared-library": "/calling-orchestration-shared-library/static-1.34080",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.6828",
  "usage-tracker-container": "/usage-tracker-container/static-1.6884",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.7830",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.3594",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3563",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6305",
  "persist-promise": "/persist-promise/static-1.3264",
  "breeze-intelligence-kit": "/breeze-intelligence-kit/static-1.4945",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.8932",
  "fsm": "/fsm/static-1.3208",
  "policy-lib": "/policy-lib/static-1.6294",
  "react-tinymce": "/react-tinymce/static-1.53941",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.8995",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.53067",
  "tinymce-plugins": "/tinymce-plugins/static-1.56181",
  "tinymce-themes": "/tinymce-themes/static-1.55037",
  "cropperjs": "/cropperjs/static-1.10",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "urlinator": "/urlinator/static-1.4063",
  "video-embed": "/video-embed/static-1.34376",
  "content-icons-ui": "/content-icons-ui/static-1.2052",
  "social-insights-client-types": "/social-insights-client-types/static-1.20730",
  "eligibility-engine-service-types": "/eligibility-engine-service-types/static-1.2798",
  "markdown-it": "/markdown-it/static-1.6",
  "cms-field-types": "/cms-field-types/static-1.4212",
  "underscore": "/underscore/static-1.8",
  "sales-views-client-types": "/sales-views-client-types/static-1.3777",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.34305",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3223",
  "highcharts": "/highcharts/static-8.94",
  "trellis-story-utils": "/trellis-story-utils/static-1.4034",
  "storybook-react": "/storybook-react/static-1.22",
  "hub-http-contrib": "/hub-http-contrib/static-1.2626",
  "interframe": "/interframe/static-3.4261",
  "tinymce-data": "/tinymce-data/static-1.39152",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.4721",
  "codemirror": "/codemirror/static-5.85",
  "layout-dnd-components": "/layout-dnd-components/static-1.11569",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.10544",
  "react-codemirror": "/react-codemirror/static-1.10162",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.12799",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.8696",
  "outpost": "/outpost/static-1.3809",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "ContentData": "/ContentData/static-1.66987",
  "layout-data-lib": "/layout-data-lib/static-1.8869",
  "browser-eslint": "/browser-eslint/static-2.57",
  "advanced-menus-core": "/advanced-menus-core/static-1.14411",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.11430",
  "ExportDialog": "/ExportDialog/static-6.9959",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.32722",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.14410",
  "ReduxMessenger": "/ReduxMessenger/static-2.9950",
  "simple-menus-lib": "/simple-menus-lib/static-1.15927"
}
};
